import { Injectable, inject } from '@angular/core';
import { AlertBox } from '@models/alert-box.model';
import { Observable } from 'rxjs';
import { ApiService } from '../core/api/api.service';

@Injectable()
export class AlertBoxService {
   private apiService = inject(ApiService);

   domainName = 'AlertBox';
   updatedMessage = 'AlertBoxUpdated';

   /** Inserted by Angular inject() migration for backwards compatibility */
   constructor(...args: unknown[]);

   constructor() {}

   get(id: string): Observable<AlertBox> {
      return this.apiService.get(this.domainName, id);
   }

   getActives(): Observable<AlertBox[]> {
      return this.apiService.get(this.domainName);
   }

   save(obj: AlertBox): Observable<string> {
      return this.apiService.put(this.domainName, obj, this.updatedMessage);
   }
}
